import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Company');
	}

	loadAll(): Observable<ePM.Logic.Company[]> {
		return this.myBaseService.loadAll(this.url);
	}
	add(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.CompanyAdd> {
		return this.myBaseService.save(tempItem, this.url + '/Add');
	}
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.Company> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	unDeleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.post(null, this.url + '/Reactivate/' + (id || ''));
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.Company> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<ePM.Logic.Company> {
		return this.myBaseService.get(id, this.url);
	}
	changePlan(obj: ePM.Logic.SubscriptionUpdate): Observable<ePM.Logic.Company> {
		return this.myBaseService.post(obj, this.url +'/ChangePlan');
	}
	search(searchTerm: string): Observable<any[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search/');
	}
}
